export default "__VITE_ASSET__ed283160__"